<template>
  <section class="formato">
    <Ano :ano="ano" />
    <div class="formato__warpper" :id="ano">
      <div class="container">
        <div class="formato__warpper__item">
          <h2>Aves no Brasil e México</h2>
          <p>
            A JBS adquire as operações de aves da empresa
            <strong>Tyson</strong> no Brasil e no México. No Brasil, a operação
            contempla três unidades de processamento completamente integradas,
            com 5.000 colaboradores. Já no México, inclui três unidades de
            processamento e capacidade adicional de 600 mil aves por dia, além
            de somar 5.400 novos colaboradores à empresa.
          </p>
        </div>
        <div class="formato__warpper__item--image">
          <img
            src="../assets/img/2014/2014-1.png"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/2014/07/29/g/20140729-44114-nac-29-eng-b9-not-qxghaah.jpg'
              )
            "
            class="fistItem"
          />

          <span
            ><i class="icon-eye"></i
            ><strong>clique nas imagens para ampliar</strong></span
          >
        </div>
        <div class="formato__warpper__item--black">
          <h2>Saída do Mapa da Fome da ONU</h2>
          <p>
            Em uma combinação de políticas públicas bem-sucedidas e uma
            organização forte da indústria de alimentação, capaz de atender a
            população,
            <strong
              >o Brasil deixou o Mapa da Fome da Organização das Nações Unidas
              (ONU)</strong
            >. Para a indústria, outro marco relevante foi a fundação da
            Associação Brasileira de Proteína Animal (ABPA), que reúne as redes
            de produção de frangos e suínos.
          </p>
          <img
            src="../assets/img/2014/2014-2.png"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/2014/09/17/g/20140917-44164-spo-24-mrt-a25-not-qhghkah.jpg'
              )
            "
            class="secondItem"
          />
        </div>
      </div>
    </div>
  </section>
  <vue-easy-lightbox
    :visible="visibleRef"
    @hide="onHide"
    :imgs="imgsRef"
    :index="indexRef"
  ></vue-easy-lightbox>
</template>
<script>
import Ano from './Ano.vue';
import VueEasyLightbox from 'vue-easy-lightbox';
import { defineComponent } from 'vue';

export default defineComponent({
  components: { Ano, VueEasyLightbox },
  props: ['ano'],
  data() {
    return {
      visibleRef: false,
      indexRef: 0,
      imgsRef: [],
    };
  },
  methods: {
    onShow() {
      this.visibleRef = true;
    },
    onHide() {
      this.visibleRef = false;
    },
    openLink(link) {
      window.open(link, '_blank');
    },
  },
});
</script>

<style scoped lang="scss">
.formato {
  .container {
    min-height: 100vh;
    scroll-snap-align: start;
    padding-top: 160px;
    display: grid;
    grid-template-columns: 331px 290px 390px;
    justify-content: space-between;
    @include media('<=desktop') {
      grid-template-columns: 1fr;
    }
  }
  &__warpper {
    position: relative;
    img {
      max-width: 100%;
      transition: 0.3s ease-in-out;
      cursor: pointer;
      &:hover {
        transform: scale(1.1);
      }
    }
    &__item {
      position: relative;
      @include media('<=desktop') {
        padding: 0 20px;
      }
      &--image {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: flex-start;
        @include media('<=desktop') {
          padding: 0 20px;
        }
        span {
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          top: 450px;
          width: 65px;
          color: color(cBlue4);
          @include media('<=desktop') {
            position: initial;
            transform: translate(0);
          }
          strong {
            color: color(cBlue4);
            font-family: font(primary);
            font-size: 0.75rem;
            font-style: normal;
            font-weight: 400;
            line-height: 116.5%;
            background: color(cGreen);
          }
          i {
            display: block;
            font-size: 1.3rem;
          }
        }
      }
      h2 {
        color: color(primary);
        font-family: font(primary);
        font-size: 2.5rem;
        font-style: normal;
        font-weight: 700;
        line-height: 110.5%;
      }
      p {
        color: color(cText);
        font-family: font(primary);
        font-size: 1.125rem;
        font-style: normal;
        font-weight: 400;
        line-height: 140%;
        margin: 20px 0 30px;
      }

      &--black {
        @include media('<=desktop') {
          padding: 40px 20px;
          background: color(cGreen);
        }
        span {
          display: block;
          width: 65px;
          color: color(cBlue);

          strong {
            color: color(cWhite);
            font-family: font(primary);
            font-size: 0.75rem;
            font-style: normal;
            font-weight: 400;
            line-height: 116.5%;
            background: color(cBlue);
          }
          i {
            display: block;
            font-size: 1.3rem;
          }
        }
        p {
          color: color(cText);
          font-family: font(primary);
          font-size: 0.875rem;
          font-style: normal;
          font-weight: 400;
          line-height: 140%;
          margin-bottom: 100px;
        }
        h2 {
          color: color(cText);
          font-family: font(primary);
          font-size: 1rem;
          font-style: normal;
          font-weight: 700;
          line-height: 140%;
          text-transform: uppercase;
          margin-block: 10px;
        }
        blockquote {
          color: color(cBlack);
          font-family: font(primary);
          font-family: JBS Text;
          font-size: 1rem;
          font-style: normal;
          font-weight: 700;
          line-height: 135%;
          margin: 10px 0;
          position: relative;
          span {
            width: initial;
            display: inline;
            font-weight: 400;
          }
          &::before {
            content: '\e901';
            font-family: 'icomoon' !important;
            display: block;
            font-size: 1rem;
            line-height: initial;
            margin-bottom: 17px;
          }
        }
      }
    }
    &::after {
      content: '';
      background: color(cGreen);
      width: 45%;
      height: 100%;
      position: absolute;
      right: 0;
      top: 0;
      z-index: -1;
      background-repeat: no-repeat;
      background-size: cover;
      @include media('<=desktop') {
        display: none;
      }
    }
  }
}
</style>
